const ReactGA = require("react-ga");

const internals = {
    currentRoute: null
};

module.exports = store => {
    const { GA_CODE } = process.env;

    if (!GA_CODE) {
        console.log("No Google Analytics code provided!");
    }

    ReactGA.initialize(GA_CODE);
    store.subscribe(() => internals.watchRouteTransition(store));
};

internals.watchRouteTransition = store => {
    const router = store.getState().router;

    if (
        router &&
        router.location &&
        router.location.pathname !== internals.currentRoute
    ) {
        internals.currentRoute = router.location.pathname;
        ReactGA.pageview(internals.currentRoute);
    }

    return;
};



// WEBPACK FOOTER //
// ./src/initializers/google-analytics.js